import { Share } from '@capacitor/share';
import { isNative } from './runtime.ts';

export type ShareResult = 'shared' | 'copied' | 'unavailable';

export async function shareUrl(url: string, title = 'Completto'): Promise<ShareResult> {
  if (isNative()) {
    try {
      await Share.share({ title, text: '같이 컴플레또 한 판!', url });
      return 'shared';
    } catch {
      // 사용자 취소 또는 미지원 — clipboard fallback
    }
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(url);
      return 'copied';
    } catch {
      return 'unavailable';
    }
  }
  return 'unavailable';
}

export async function copyText(text: string): Promise<boolean> {
  if (!navigator.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
